// libs
import * as React from 'react'

// components
import BackbuttonHeader from 'src/components/header/common/backbutton_header/backbutton_header'
import { URLConsumer } from 'src/containers/url_provider/url_provider'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import initTracker, { HEADER_DETAILS } from 'src/utils/reporting/events_tracking/events_tracking'

// helpers

import { ContentItemQuery } from '@lopo-tech/lopo-api'
import { MoreButton } from 'src/components/post/shared/more_button/more_button'
import { textResources } from 'src/lang/de'
import './post_header_details.scss'

const cls = CLASS_PREFIX + 'post-header-details'
const clsMoreWrapper = `${cls}__more-wrapper`

const tracker = initTracker(HEADER_DETAILS)

export interface IProps {
  handleBackButton?: () => void;
  contentItem?: ContentItemQuery['contentItem'];
  postUpdateOpen: boolean;
}

/**
 * details header
 */
const PostHeaderDetails: React.FC<IProps> = ({ contentItem, handleBackButton, postUpdateOpen }) => (
  <div className={cls}>
    <BackbuttonHeader
      handleBackButton={handleBackButton}
      title={contentItem?.title || textResources.shared.lokalportal}
    >
      {contentItem &&
        <URLConsumer>
          {({ getNewsfeedRoute }) => (
            <div className={clsMoreWrapper} >
              <MoreButton
                contentItem={contentItem}
                postUpdateOpen={postUpdateOpen}
                getNewsfeedRoute={getNewsfeedRoute}
                tracking={{ tracker, trackingObj: HEADER_DETAILS }}
              />
            </div>
          )}
        </URLConsumer>
      }
    </BackbuttonHeader>
  </div>
)

/* set displayname to not have a component without a name */
PostHeaderDetails.displayName = 'PostHeaderDetails'

export default PostHeaderDetails
